import React, { useMemo, useState } from "react";
import StripePaymentForm from "./StripePaymentForm";
import EventData from "./EventData";
import { Elements } from "@stripe/react-stripe-js";
import {
  Appearance,
  loadStripe,
  StripeElementsOptions,
} from "@stripe/stripe-js";

interface StripeContainerProps {
  event: EventData;
}

function StripeContainer(props: StripeContainerProps) {
  function getPaymentTotal(numberOfTickets: number, price: number): number {
    const totalAmount = numberOfTickets * price;
    return totalAmount * 100;
  }

  const [eventData, setEventData] = useState<EventData>(props.event);
  const appearance: Appearance = {
    theme: "night",
  };
  const [stripeOptions, setStripeOptions] = useState<StripeElementsOptions>({
    mode: "payment",
    amount: getPaymentTotal(1, props.event.price),
    currency: "gbp",
    paymentMethodCreation: "manual",
    appearance: appearance,
  });

  function updateNumberOfTickets(price: number, numberOfTickets: number) {
    const totalAmount = getPaymentTotal(numberOfTickets, price);

    setStripeOptions((existingOptions) => {
      return {
        ...existingOptions,
        amount: totalAmount,
      };
    });
  }

  const stripePromise = useMemo(
    () => loadStripe(props.event.paymentClientId),
    [props.event],
  );

  return (
    <Elements stripe={stripePromise} options={stripeOptions}>
      <StripePaymentForm
        event={eventData}
        updateNumberOfTicketsCallback={updateNumberOfTickets}
      />
    </Elements>
  );
}

export default StripeContainer;
